export const SEND_STICKY = 'SEND_STICKY'
export const SET_LOADING = 'SET_LOADING'
export const UPDATE_AUTH  = 'UPDATE_AUTH'
export const SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE  = 'SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE'
export const UPDATE_ROUTES  = 'UPDATE_ROUTES'

export const UPDATE_USER = 'UPDATE_USER'
export const CLEAR_ALL_DATA  = 'CLEAR_ALL_DATA'

export const SET_MEMBER  = 'SET_MEMBER'
export const SET_CLUB  = 'SET_CLUB'
export const REMOVE_FROM_CART  = 'REMOVE_FROM_CART'
export const SET_MODE_PAYEMENT  = 'SET_MODE_PAYEMENT'
export const ADD_TO_CART  = 'ADD_TO_CART'
export const SET_ID_CLUB_SELECTED  = 'SET_ID_CLUB_SELECTED'
export const SET_GRADES  = 'SET_GRADES'
export const SET_VALIDATED_CART  = 'SET_VALIDATED_CART'
export const SET_ORDER_PAYED  = 'SET_ORDER_PAYED'
export const SET_MODE_LIVRAISON  = 'SET_MODE_LIVRAISON'
export const SET_SOUS_MODE_PAYEMENT  = 'SET_SOUS_MODE_PAYEMENT'
export const SET_STEP_ORDER  = 'SET_STEP_ORDER'
export const SET_ADRESS_FOR_ORDER  = 'SET_ADRESS_FOR_ORDER'
export const SET_ADRESS_FACTURATION_FOR_ORDER  = 'SET_ADRESS_FACTURATION_FOR_ORDER'
export const SET_TITUL_CARD_NAME  = 'SET_TITUL_CARD_NAME'
export const SET_DATA_TO_SYNCEDDATA_VUEX  = 'SET_DATA_TO_SYNCEDDATA_VUEX'
export const RESET_ORDER  = 'RESET_ORDER'
export const SET_STRIPE_CLIENT_SECRET_TOKEN  = 'SET_STRIPE_CLIENT_SECRET_TOKEN'
export const SET_STRIPE_PAYMENT_METHOD  = 'SET_STRIPE_PAYMENT_METHOD'
export const SET_CARD_INFO  = 'SET_CARD_INFO'
export const SET_STRIPE_OBJECT  = 'SET_STRIPE_OBJECT'
export const SET_ID_ORDER  = 'SET_ID_ORDER'







// WEBPACK FOOTER //
// ./src/vuex/mutations-type.js